import { app } from '../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public', {
        abstract: true,
        url: '',
        component: 'public',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/public.state.js